"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mapResponseValue = exports.getNextLink = exports.getResponseValue = exports.getValue = void 0;

var getValue = function getValue(response) {
  return response !== undefined && response !== null ? response.value : undefined;
};

exports.getValue = getValue;

var getResponseValue = function getResponseValue(payload) {
  return payload.response !== undefined && payload.response !== null ? payload.response.value : undefined;
};

exports.getResponseValue = getResponseValue;

var getNextLink = function getNextLink(payload) {
  return payload.response !== undefined && payload.response !== null ? payload.response.nextLink : undefined;
};

exports.getNextLink = getNextLink;

var mapResponseValue = function mapResponseValue(type) {
  return function (payload) {
    return {
      type: type,
      payload: getResponseValue(payload)
    };
  };
};

exports.mapResponseValue = mapResponseValue;